import { call, put, select } from 'redux-saga/effects';
import {
  deleteUserFailure,
  deleteUserSuccess,
  fetchUsersRequest,
} from '../actions';
import { ApiError, ApiResponse } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { deleteUser } from '../api';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn } from 'store/app/actions';
import { DeleteUserRequestAction } from '../types';
import { MessageStatus, TablePermission } from 'store/api/enums';
import { getOrgOrganisations } from 'store/organisation/selectors';
import { updateEntityMembers } from 'store/organisation/actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* deleteUserSaga(action: DeleteUserRequestAction) {
  try {
    let err: ApiError | null;
    const { userToDeleteId } = action.payload;
    const response: ApiResponse = yield call(deleteUser, userToDeleteId);

    err = checkResponse(response?.responseMessage);
    if (err && response.responseMessage.status === MessageStatus.UNAUTHORIZED) {
      yield put(fetchUsersRequest());
    }
    if (err) throw err;
    yield put(deleteUserSuccess(userToDeleteId));
    const organisations = yield select(getOrgOrganisations);
    for (let i = 0; i < organisations.length; i++) {
      const userIndex = organisations[i].users.findIndex(
        (u) => u.userUuid === userToDeleteId
      );
      if (userIndex > -1) {
        yield put(
          updateEntityMembers(
            organisations[i].uuid,
            organisations[i].users[userIndex],
            TablePermission.NONE
          )
        );
      }
    }
    //yield put(fetchUsersRequest());
    const message: MessageData = {
      title: i18n.t('common.success'),
      description: i18n.t('notifications.user-successfully-deleted'),
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(deleteUserFailure());
  }
}
